// src/components/common/Loader.tsx

import React from 'react';
import { Center, Stack, useMantineColorScheme } from '@mantine/core';

interface LoaderProps {
  fullScreen?: boolean;
}

export const Loader: React.FC<LoaderProps> = ({
  fullScreen = false,
}) => {
  const { colorScheme } = useMantineColorScheme();

  const isDark = colorScheme === 'dark';

  // DARK MODE -> white logo
  // LIGHT MODE -> dark logo
  const logoSrc = isDark
    ? '/assets/images/favicon-64x64.png'
    : '/assets/images/loader_dark.png';

  const content = (
    <Stack align="center" gap="xs">
      {/* LOGO */}
      <img
        src={logoSrc}
        alt="Thalvora Exports"
        style={{
          width: 90,
          height: 90,
          objectFit: 'contain',
          animation: 'float 2s ease-in-out infinite',
        }}
      />

      {/* WATER EFFECT */}
      <div
        style={{
          fontSize: 32,
          letterSpacing: 8,
          color: isDark ? '#7dd3fc' : '#0284c7',
          animation: 'waterFlow 1.2s linear infinite',
        }}
      >
        ≈ ≈ ≈
      </div>

      {/* ANIMATIONS */}
      <style>
        {`
          @keyframes float {
            0% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-8px);
            }
            100% {
              transform: translateY(0px);
            }
          }

          @keyframes waterFlow {
            0% {
              transform: translateX(-10px);
              opacity: 0.6;
            }
            50% {
              transform: translateX(10px);
              opacity: 1;
            }
            100% {
              transform: translateX(-10px);
              opacity: 0.6;
            }
          }
        `}
      </style>
    </Stack>
  );

  if (fullScreen) {
    return (
      <Center
        style={{
          height: '100vh',
          background: isDark ? '#0f172a' : '#ffffff',
          transition: 'background 0.3s ease',
        }}
      >
        {content}
      </Center>
    );
  }

  return (
    <Center
      style={{
        height: '100%',
        minHeight: 200,
      }}
    >
      {content}
    </Center>
  );
};